import React, { useState, useEffect } from 'react'
import { CardText, Col, Row } from 'reactstrap'
import DPTextBox from 'framework/components/DPTextBox'
import DPDropDown from 'framework/components/DPDropDown'

const UserMasterTab2 = ({
    add1Value,
    add1OnChange,
    add2Value,
    add2OnChange,
    add3Value,
    add3OnChange,
    add4Value,
    add4OnChange,
    areaValue,
    areaonChange,
    phoneValue,
    phoneOnChange,
    emailValue,
    emailOnChange,
    disable
}) => {


    const [area, SetArea] = useState([])

    useEffect(() => {

        //********Get job designation dropdown data */
        function getArea() {
            const authToken = localStorage.getItem("authToken")
            var requestOptions = {
                method: 'GET',
                headers: {
                    "Authorization": `Bearer ${authToken}`
                },
                redirect: 'follow'
            };
            const ApiURL = window.Links.ApiURL
            fetch(`${ApiURL}SupplierArea/Select/`, requestOptions)
                .then(response => response.json())
                .then(result => {
                    SetArea(result.data)
                }).catch(error => console.log('error', error));
        }
        //********End Get job designation dropdown data */

        getArea()

    }, [])


    return (
        <React.Fragment>
            <div>
                <Row>
                    <Col sm="12">
                        <CardText className="mb-4-sm">
                            <Row>
                                <Col sm={12} md={6} className="mb-4-sm">
                                    <DPTextBox
                                        rowClass="mb-4-sm"
                                        labelText="Address *"
                                        textType="text"
                                        maxLength="50"
                                        placeholder="Address Line 1"
                                        value={add1Value}
                                        onChange={add1OnChange}
                                        disabled={disable} />
                                    <DPTextBox
                                        rowClass="mb-4-sm"
                                        labelText="&nbsp;"
                                        textType="text"
                                        maxLength="50"
                                        placeholder="Address Line 2"
                                        value={add2Value}
                                        onChange={add2OnChange}
                                        disabled={disable} />
                                    <DPTextBox
                                        rowClass="mb-4-sm"
                                        labelText="&nbsp;"
                                        textType="text"
                                        maxLength="50"
                                        placeholder="Address Line 3"
                                        value={add3Value}
                                        onChange={add3OnChange}
                                        disabled={disable} />
                                    <DPTextBox
                                        rowClass="mb-4-sm"
                                        labelText="&nbsp;"
                                        textType="text"
                                        maxLength="50"
                                        placeholder="Address Line 4"
                                        value={add4Value}
                                        onChange={add4OnChange}
                                        disabled={disable} />

                                </Col>
                            </Row>
                            <Row>
                                <Col sm={12} md={6} className="mb-4-sm">
                                    <DPDropDown
                                        rowClass="mb-4-sm"
                                        labelText="Area of the User *"
                                        textType="text"
                                        selectedGroup={areaValue}
                                        optionGroup={area}
                                        onChange={areaonChange}
                                        disabled={disable} />
                                    <DPTextBox
                                        rowClass="mb-4-sm"
                                        labelText="Phone Number *"
                                        placeholder="+94XXXXXXXXX"
                                        textType="text"
                                        maxLength="12"
                                        value={phoneValue}
                                        onChange={phoneOnChange}
                                        disabled={disable} />
                                    <DPTextBox
                                        rowClass="mb-4-sm"
                                        labelText="Email Address"
                                        textType="text"
                                        maxLength="70"
                                        value={emailValue}
                                        onChange={emailOnChange}
                                        disabled={disable} />
                                </Col>
                            </Row>
                        </CardText>
                    </Col>
                </Row>
            </div>
        </React.Fragment>
    )

}

export default UserMasterTab2